import { useEffect } from 'react';
import { Account, CheckOut } from '../../types';
import { useHistory } from 'react-router';

type GetBuyerAccountsProps = {
  accounts: Account[];
  selectedAccount?: Account | undefined;
  checkOut: CheckOut;
  getAccounts: (checkOutId: string) => Promise<any>;
  getSupplierBuyerAssociation: (checkOutId: string, buyerAccountId: string) => Promise<any>;
  setSelectedAccount: (account: Account) => void;
};

const GetBuyerAccounts = (props: GetBuyerAccountsProps) => {
  const { checkOut, accounts, getSupplierBuyerAssociation, setSelectedAccount } = props;
  const history = useHistory();

  useEffect(() => {
    if (checkOut && accounts && accounts.length === 1) {
      setSelectedAccount(accounts[0]);
      if (checkOut.productCode === 'ST') {
        getSupplierBuyerAssociation(checkOut.id, accounts[0].gcAccountId);
      }
      history.push({
        pathname: '/confirm-checkout',
      });
    }
  }, [checkOut, accounts]);

  return null;
};

export default GetBuyerAccounts;
